module.exports = __webpack_public_path__ + "static/media/laddu_page04.47d79675.png";